import { render, staticRenderFns } from "./application-confirm-success.vue?vue&type=template&id=0815ce72&"
import script from "./application-confirm-success.vue?vue&type=script&lang=js&"
export * from "./application-confirm-success.vue?vue&type=script&lang=js&"
import style0 from "./application-confirm-success.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports